import { render, staticRenderFns } from "./CertifiedContract.vue?vue&type=template&id=a849aec4&scoped=true"
import script from "./CertifiedContract.vue?vue&type=script&lang=js"
export * from "./CertifiedContract.vue?vue&type=script&lang=js"
import style0 from "./CertifiedContract.vue?vue&type=style&index=0&id=a849aec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a849aec4",
  null
  
)

export default component.exports